import {
  Bell,
  Briefcase,
  CreditCard,
  Gift,
  Home,
  Key,
  Phone,
  UserPlus,
  Users,
  type LucideIcon,
} from "lucide-react";

export const CHECKLIST_ICON_MAP: Record<string, LucideIcon> = {
  users: Users,
  phone: Phone,
  "user-plus": UserPlus,
  "credit-card": CreditCard,
  home: Home,
  briefcase: Briefcase,
  key: Key,
  bell: Bell,
  gift: Gift,
};
